/**
 * Header / Navbar JavaScript
 * Handles mega menu interactions, mobile menu, and navigation
 */

document.addEventListener('DOMContentLoaded', function() {
  const mobileMenu = document.getElementById('mobile-menu');
  const navbar = document.querySelector('.navbar');
  
  // Navigation history for mobile menu
  let menuHistory = [];
  
  // ============================================
  // MEGA MENU - Desktop
  // ============================================
  
  const megamenus = document.querySelectorAll('.megamenu');
  
  megamenus.forEach(megamenu => {
    const categoryBtns = megamenu.querySelectorAll('.megamenu__category-btn');
    const productGrids = megamenu.querySelectorAll('.megamenu__product-grid');
    
    categoryBtns.forEach(btn => {
      btn.addEventListener('mouseenter', function() {
        const categoryHandle = this.dataset.category;
        
        // Update active states
        categoryBtns.forEach(b => b.classList.remove('is-active'));
        this.classList.add('is-active');
        
        // Show corresponding product grid
        productGrids.forEach(grid => {
          if (grid.dataset.category === categoryHandle) {
            grid.classList.add('is-active');
          } else {
            grid.classList.remove('is-active');
          }
        });
      });
    });
  });
  
  // ============================================
  // MOBILE MENU
  // ============================================
  
  // Open mobile menu
  document.querySelectorAll('[data-action="open-mobile-menu"]').forEach(btn => {
    btn.addEventListener('click', function() {
      openMobileMenu();
    });
  });
  
  // Close mobile menu
  document.querySelectorAll('[data-action="close-mobile-menu"]').forEach(btn => {
    btn.addEventListener('click', function() {
      closeMobileMenu();
    });
  });
  
  // Back button
  document.querySelectorAll('[data-action="back"]').forEach(btn => {
    btn.addEventListener('click', function() {
      goBack();
    });
  });
  
  // Show submenu
  document.querySelectorAll('[data-action="show-submenu"]').forEach(btn => {
    btn.addEventListener('click', function() {
      const target = this.dataset.target;
      showSubmenu(target);
    });
  });
  
  // Show products
  document.querySelectorAll('[data-action="show-products"]').forEach(btn => {
    btn.addEventListener('click', function() {
      const target = this.dataset.target;
      showProducts(target);
    });
  });
  
  function openMobileMenu() {
    mobileMenu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    menuHistory = ['main'];
    updateBackButton();
  }
  
  function closeMobileMenu() {
    mobileMenu.classList.remove('is-open');
    document.body.style.overflow = '';
    
    // Reset to main menu after animation
    setTimeout(() => {
      hideAllSubmenus();
      showMainMenu();
      menuHistory = [];
      updateBackButton();
    }, 300);
  }
  
  function showSubmenu(handle) {
    hideAllSubmenus();
    const submenu = mobileMenu.querySelector(`[data-submenu="${handle}"]`);
    if (submenu) {
      submenu.style.display = 'block';
      menuHistory.push({ type: 'submenu', handle });
      updateBackButton();
      updateTitle(submenu.querySelector('.mobile-menu__submenu-title')?.textContent || 'Menu');
    }
  }
  
  function showProducts(handle) {
    hideAllSubmenus();
    const products = mobileMenu.querySelector(`[data-products="${handle}"]`);
    if (products) {
      products.style.display = 'block';
      menuHistory.push({ type: 'products', handle });
      updateBackButton();
      updateTitle(products.querySelector('.mobile-menu__submenu-title')?.textContent || 'Products');
    }
  }
  
  function goBack() {
    if (menuHistory.length <= 1) return;
    
    menuHistory.pop();
    const previous = menuHistory[menuHistory.length - 1];
    
    hideAllSubmenus();
    
    if (previous === 'main' || !previous) {
      showMainMenu();
      updateTitle('Menu');
    } else if (previous.type === 'submenu') {
      const submenu = mobileMenu.querySelector(`[data-submenu="${previous.handle}"]`);
      if (submenu) {
        submenu.style.display = 'block';
        updateTitle(submenu.querySelector('.mobile-menu__submenu-title')?.textContent || 'Menu');
      }
    }
    
    updateBackButton();
  }
  
  function hideAllSubmenus() {
    mobileMenu.querySelectorAll('.mobile-menu__submenu, .mobile-menu__products').forEach(el => {
      el.style.display = 'none';
    });
    mobileMenu.querySelector('[data-level="main"]').style.display = 'none';
  }
  
  function showMainMenu() {
    mobileMenu.querySelector('[data-level="main"]').style.display = 'block';
  }
  
  function updateBackButton() {
    const backBtn = mobileMenu.querySelector('[data-action="back"]');
    if (menuHistory.length > 1) {
      backBtn.style.display = 'flex';
    } else {
      backBtn.style.display = 'none';
    }
  }
  
  function updateTitle(title) {
    const titleEl = mobileMenu.querySelector('.mobile-menu__title');
    if (titleEl) {
      titleEl.textContent = title;
    }
  }
  
  // Initialize - show main menu by default
  const mainList = mobileMenu?.querySelector('[data-level="main"]');
  if (mainList) {
    mainList.style.display = 'block';
  }
  
  // ============================================
  // SEARCH (placeholder - implement as needed)
  // ============================================
  
  document.querySelectorAll('[data-action="open-search"]').forEach(btn => {
    btn.addEventListener('click', function() {
      // Implement search modal opening
      console.log('Open search');
    });
  });
});

function updateNavbarCartCount() {
  fetch(`${window.routes.cart_url}.js`)
    .then((res) => res.json())
    .then((cart) => {
      document.querySelectorAll('#NavbarCartCount, .navbar__cart-count').forEach((el) => {
        el.textContent = cart.item_count;
      });
    })
    .catch(console.error);
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('cart:refresh', updateNavbarCartCount);

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      setTimeout(updateNavbarCartCount, 700);
    }
  });

  updateNavbarCartCount();
});
